export function urlEncoded(obj: Record<string, any>): string {
  const p = new URLSearchParams(obj).toString();

  return `?${p}`;
}
